import * as React from "react";

import { MenuRowInner } from "./atoms/MenuRowInner";
import { MenuLink } from "./atoms/MenuLink";
import { ExpansionButton } from "./ExpansionButton";
import { IMenuItem } from "../../IMenuItem";

interface Props {
  menuItem: IMenuItem;
  level: number;
  expanded: boolean;
  toggleExpand: () => void;
}

export const MenuItem = ({
  menuItem,
  level,
  expanded,
  toggleExpand
}: Props) => (
  <MenuRowInner>
    <MenuLink
      className={`level-` + level}
      href={menuItem.link}
      level={level}
      data-id={menuItem.tracking}
      componentType={"navMobileMenuItem"}
    >
      {menuItem.title}
    </MenuLink>
    {menuItem.children &&
      menuItem.children.length > 0 && (
        <ExpansionButton expanded={expanded} toggleExpand={toggleExpand} />
      )}
  </MenuRowInner>
);
